<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <popup-add-price-shift-window ref="popupAddPriceShiftWindow" :venueId="activeVenueId" />

    <div class="flex justify-between">
      <p>Price shift windows can be used to change the active price group for a period of time.</p>
      <div class="flex justify-end">
        <vs-button icon="add" @click="$refs.popupAddPriceShiftWindow.show()" type="relief" color="primary" class="mr-3"
          >Add window</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div class="data-list-list-view">
      <vs-table ref="table" class="mt-4" pagination search :max-items="100" :data="windowsSorted" @selected="onClicked">
        <template slot="header">
          <div class="flex mb-2"></div>
          <vs-spacer />
        </template>

        <template slot="thead">
          <vs-th>Start</vs-th>
          <vs-th sort-key="name">End</vs-th>
          <vs-th>Terminal</vs-th>
          <vs-th>Price group</vs-th>
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>{{ formatDateTime(tr.windowStart) }}</vs-td>
              <vs-td>{{ formatDateTime(tr.windowEnd) }}</vs-td>
              <vs-td>{{ terminalName(tr.terminalId) }}</vs-td>
              <vs-td>{{ priceGroupName(tr.priceGroupId) }}</vs-td>
              <vs-td>
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="onClickDelete(tr.id)" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popupAddPriceShiftWindow from "./PopupAddPriceShiftWindow.vue";
import moment from "moment";
export default {
  props: {
    venueId: {
      type: String,
      default: undefined,
      required: false
    }
  },
  components: {
    popupAddPriceShiftWindow
  },
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        this.activeVenueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          this.activeVenueId = this.$store.getters["venues/activeVenueId"];
        }

        console.log("venueId is now-____", this.activeVenueId, this.venueId);

        await Promise.all([
          this.$store.dispatch("pos/priceShiftWindows/getPriceShiftWindows", this.activeVenueId),
          this.$store.dispatch("pos/venues/getPriceGroups", this.activeCountry.id),
          this.$store.dispatch("pos/venues/getTerminals", this.activeVenueId)
        ]);
        this.isLoading = false;
      },
      immediate: true
    }
  },
  data() {
    return {
      isLoading: true,
      deleteId: null,
      countries: [
        {
          id: "dk",
          name: "Denmark"
        },
        {
          id: "no",
          name: "Norway"
        },
        {
          id: "fi",
          name: "Finland"
        },
        {
          id: "uk",
          name: "United Kingdom"
        }
      ],

      activeVenueId: null
    };
  },
  methods: {
    formatDateTime(dateTime) {
      return moment(dateTime).format("MMMM Do, HH:mm");
    },
    async deletePriceShiftWindow() {
      await this.$store.dispatch("pos/priceShiftWindows/deletePriceShiftWindow", {
        itemId: this.deleteId,
        venueId: this.activeVenueId
      });
      this.deleteId = null;
    },
    onClickDelete(itemId) {
      this.deleteId = itemId;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm delete",
        text: `Are you sure you want to delete this price shift window?`,
        accept: this.deletePriceShiftWindow
      });
    },
    onClicked(item) {
      // this.$refs.productSidebar.show(item.id);
    }
  },
  computed: {
    ...mapGetters({
      activeCountry: "venues/activeCountry",
      terminals: "pos/venues/terminals",
      priceShiftWindows: "pos/priceShiftWindows/priceShiftWindows",
      priceGroups: "pos/venues/priceGroups"
    }),
    priceGroupName() {
      return priceGroupId => {
        const terminal = this.priceGroups.find(terminal => terminal.priceGroupId === priceGroupId);
        return terminal ? terminal.name : "";
      };
    },
    terminalName() {
      return terminalId => {
        if (!terminalId) return "All terminals";
        const terminal = this.terminals.find(terminal => terminal.id === terminalId);
        return terminal ? terminal.name : "";
      };
    },
    windowsSorted() {
      return this.priceShiftWindows.toSorted((a, b) => {
        return new Date(a.windowStart) - new Date(b.windowStart);
      });
    }
  }
};
</script>